/**
 * @deprecated use `track value.prop` (https://angular.dev/api/core/@for)
 */
export const trackByProp = <T = any>({
  prop,
  fallback = true,
}: {
  prop: keyof T;
  fallback?: boolean;
}): (<U extends T>(index: number, object: U) => U[typeof prop] | U) =>
  fallback
    ? <U extends T>(index: number, object: U) => object[prop] ?? object
    : <U extends T>(index: number, object: U) => object[prop];

/**
 * @deprecated use `track value` (https://angular.dev/api/core/@for)
 */
export const trackByValue = <T>(index: number, value: T): T => value;

/**
 * @deprecated use `track $index` (https://angular.dev/api/core/@for)
 */
export const trackByIndex = (index: number, value?: any): number => index;
